<template>
  <a-popover
    v-model="visible"
    :visible-arrow="false"
    trigger="click"
    placement="bottom"
    popper-class="confirm-pop"
  >
    <div
      slot="content"
      class="pop-form-box"
    >
      <div class="pop-content">
        <div class="untie-tip-box dialog-tip-box">
          <!-- <div class="confirm-d-tit">
            <span>{{ itemData.truename }}</span>
          </div>
          <p v-html="txtTip" /> -->
          <i class="icon iconfont iconicon-test68" />
          <h2>{{ $t('message["491"]') }}<span class=" ml-16"> <a-tag>{{ itemData.truename }}</a-tag></span></h2>
          <div class="d-tip-con">
            <p v-html="txtTip" />
          </div>
          <div class="pop-footer">
            <a-button
              v-if="!needWidthBtn"
              type="primary"
              :disabled="submitting"
              @click="confirmHandle"
            >
              {{ $t('message["915"]') }}
            </a-button>
            <a-button
              v-if="needWidthBtn"
              @click="visible = false"
            >
              {{ $t('message["1276"]') }}
            </a-button>
            <a-button
              v-if="!needWidthBtn"
              @click="visible = false"
            >
              {{ $t('message["896"]') }}
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <a
      class="form-del-btn"
    >{{ $t('message["962"]') }}</a>
  </a-popover>
</template>
<script>
import { mapState, mapActions } from 'vuex'
// import Popup from '@/common/components/Popup'
export default {
  components: {
    // Popup
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      submitting: false,
      visible: false,
      needWidthBtn: false,
      txtTip: this.$t('message["151"]') + '？'
    }
  },
  computed: {
    ...mapState('organization/person', ['itemData', 'cId', 'isAdmin', 'datas'])
  },
  methods: {
    ...mapActions('organization/person', ['ajaxDelUser', 'fetchCurrentDatas', 'fetchItemInfoDatas']),
    async confirmHandle () {
      this.submitting = true
      const chain = await this.ajaxDelUser()
      chain.params({ userid: this.itemData.userid, cid: this.cId })
        .onSuccess(async (res) => {
          if (res.redirect * 1 === 1) {
            this.$router.push({ name: 'OrgIndex' })
          } else {
            const res = await this.fetchCurrentDatas({ cid: this.cId })
            res.params({ cid: this.cId, isadmin: this.isAdmin })
              .fetch()
          }
          this.visible = false
        })
        .onNetSuccess((res) => {
          if (res.data.error === 104) {
            this.submitting = false
            this.txtTip = this.$t('message["852"]')
            this.needWidthBtn = true
          }
        })
        .config({ warn: false })
        .fetch()
      this.submitting = false
    }
  }
}
</script>
<style lang="scss"  scoped>
.form-del-btn {
  padding: 0 12px;
  height: 32px;
  border-radius: 4px;
  border: solid 1px #f57676;
  background-color: #f57676;
  color: #fff;
  display: inline-block;
  line-height: 32px;
  margin-right: 16px;
}

// .form-del-btn:hover {
//   color: #f57676;
// }
</style>
